import { render, staticRenderFns } from "./Cars_Consultora.vue?vue&type=template&id=2d872b85&scoped=true&"
import script from "./Cars_Consultora.vue?vue&type=script&lang=js&"
export * from "./Cars_Consultora.vue?vue&type=script&lang=js&"
import style0 from "./Cars_Consultora.vue?vue&type=style&index=0&id=2d872b85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d872b85",
  null
  
)

export default component.exports